import { HTTP_METHODS } from '@studio/constants/axios';
import { PLAYER_CONFIG_API_V1 } from '@studio/constants/env-variables';
import type { PlayerProfiles } from '@studio/types';

export const list = {
  [HTTP_METHODS.GET]: {
    url: `${PLAYER_CONFIG_API_V1}/customers/@customerId/configs/list`,
    response: [] as PlayerProfiles.Get.ProfileListItem[],
    method: HTTP_METHODS.GET,
  },
};
